import { cmsLandingPageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-landing-page-route-path';
import { cmsSimplePageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-simple-page-route-path';
import { promotionsRoutePath } from '@bcf-v2/routes-statics/common/app/paths/promotions-route-path';
import { supportRoutePath } from '@bcf-v2/routes-statics/common/app/paths/support-route-path';
import { liveCasinoRoutePath } from '@bcf-v2/routes/casino/app/paths/live-casino-route-path';
import { slotsRoutePath } from '@bcf-v2/routes/casino/app/paths/slots-route-path';
import { tableGamesRoutePath } from '@bcf-v2/routes/casino/app/paths/table-games-route-path';
import { tournamentsRoutePath } from '@bcf-v2/routes/casino/app/paths/tournaments-route-path';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { homeRoutePath } from '@bcf-v2/routes/common/app/paths/home-route-path';
import { FooterLink } from '../types';

export const footerLinksFn = (): FooterLink[][] => [
  [
    {
      url: cmsSimplePageRoutePath('about-us'),
      title: $localize`About us`
    },
    {
      url: 'https://lvbetpartners.lv/',
      title: $localize`Affiliates`
    },
    {
      url: 'https://lvbet.lv/casino-blog/',
      title: $localize`Casino Blog`
    }
  ],
  [
    {
      url: homeRoutePath(),
      title: $localize`Casino`
    },
    {
      url: `https://lvbet.lv/sports/${langRouteI18n()}`,
      title: $localize`Sports`
    },
    {
      url: liveCasinoRoutePath(),
      title: $localize`Live Casino`
    },
    {
      url: slotsRoutePath(),
      title: $localize`Slots`
    },
    {
      url: tableGamesRoutePath(),
      title: $localize`Table Games`
    },
    {
      url: promotionsRoutePath(),
      title: $localize`Bonuses`
    }
  ],
  [
    {
      url: tournamentsRoutePath(),
      title: $localize`Tournaments`
    },
    {
      url: cmsLandingPageRoutePath('mobile-application'),
      title: $localize`Mobile application`
    },
    {
      url: cmsLandingPageRoutePath('vip-club'),
      title: $localize`Vip Club`
    }
  ],
  [
    {
      url: supportRoutePath(),
      title: $localize`Support`
    },
    {
      url: cmsSimplePageRoutePath('terms-and-conditions'),
      title: $localize`Terms and conditions`
    },
    {
      url: cmsSimplePageRoutePath('responsible-gaming'),
      title: $localize`Responsible gaming`
    },
    {
      url: cmsSimplePageRoutePath('privacy-policy'),
      title: $localize`Privacy Policy`
    },
    {
      url: cmsSimplePageRoutePath('cookies-policy'),
      title: $localize`Cookies Policy`
    },
    {
      url: cmsSimplePageRoutePath('sitemap'),
      title: $localize`Sitemap`
    }
  ]
];
